export const environment = {
  production: false,
  env: 'stg',
  version: 'stg-0d992f64',
  feedbackDelay: 5000,
  api: 'https://stg.api.roz.copec.cl',
};
